import { useState } from 'react';
import { faqItems } from '@/mocks/categories';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqStructuredData = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return (
    <section className="py-20 md:py-28 bg-background-50">
      {/* Schema.org Structured Data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqStructuredData) }}
      />

      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          {/* Left - Large dark card with image overlap */}
          <div className="lg:w-[38%] relative">
            <div className="bg-foreground-950 rounded-3xl p-10 md:p-14 relative overflow-hidden">
              {/* Decorative quote */}
              <span className="font-heading text-8xl text-accent-200/30 leading-none block mb-6 select-none">
                &ldquo;
              </span>
              <div className="space-y-6 mb-8">
                <p className="text-background-50/90 text-base leading-relaxed">
                  Q: Is Superbuy Spreadsheet official?
                </p>
                <p className="text-background-100/70 text-sm leading-relaxed">
                  A: This is an independent resource hub. We are not affiliated with official Superbuy services but provide comprehensive educational content and curated resource links to help shoppers make informed decisions.
                </p>
                <p className="text-background-50/90 text-base leading-relaxed pt-4">
                  Q: Are spreadsheet links safe?
                </p>
                <p className="text-background-100/70 text-sm leading-relaxed">
                  A: Always verify seller ratings, check reviews, and cross-reference product information before making any purchase. Spreadsheet data is community-compiled and should be used as a research starting point.
                </p>
              </div>
              <div className="border-t border-background-50/10 pt-6">
                <p className="text-background-100/40 text-xs">Updated July 2026</p>
                <p className="text-background-100/40 text-xs mt-1">500+ Curated Resources</p>
              </div>
            </div>
            {/* Overlapping image */}
            <div className="hidden lg:block absolute -right-8 top-1/2 -translate-y-1/2 w-[200px] aspect-[3/4] rounded-2xl overflow-hidden border-4 border-background-50">
              <img
                src="https://readdy.ai/api/search-image?query=Close%20up%20of%20an%20organized%20shopping%20planner%20notebook%20with%20colorful%20sticky%20tabs%20and%20handwritten%20category%20notes%20resting%20on%20a%20warm%20wooden%20desk%20beside%20a%20steaming%20cup%20of%20tea%20and%20a%20minimal%20brass%20pen%20holder%20soft%20natural%20light%20from%20a%20window%20creating%20a%20cozy%20productive%20atmosphere%20editorial%20lifestyle%20photography%20refined%20aesthetic%20clean%20composition&width=400&height=534&seq=faq-overlay-v2&orientation=portrait"
                alt="Superbuy Spreadsheet FAQ resource guide"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Right - FAQ Accordion */}
          <div className="lg:w-[62%]">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-2">
              Frequently Asked Questions
            </h2>
            <p className="text-foreground-500 text-sm mb-10">
              Everything you need to know about Superbuy Spreadsheet resources
            </p>

            <div className="space-y-3">
              {faqItems.map((item, index) => (
                <div
                  key={index}
                  className="border border-background-200 rounded-xl overflow-hidden"
                >
                  <button
                    onClick={() => setOpenIndex(openIndex === index ? null : index)}
                    className="w-full flex items-center justify-between px-6 py-4 text-left hover:bg-background-100/50 transition-colors cursor-pointer"
                  >
                    <span className="font-label font-semibold text-sm text-foreground-800 pr-4">
                      {item.question}
                    </span>
                    <span className="shrink-0 w-6 h-6 flex items-center justify-center">
                      <i
                        className={`text-foreground-400 transition-transform duration-200 text-lg ${
                          openIndex === index ? 'ri-subtract-line' : 'ri-add-line'
                        }`}
                      ></i>
                    </span>
                  </button>
                  {openIndex === index && (
                    <div className="px-6 pb-5">
                      <p className="text-sm text-foreground-600 leading-relaxed">
                        {item.answer}
                      </p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}